import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=3b2275a4&"
import script from "./IconMenu.vue?vue&type=script&lang=ts&"
export * from "./IconMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports